import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const CampaignIdCell = styled.span`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const CampaignIdText = styled.span`
  cursor: default;
`;

export const ActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const EmptyStateWrapper = styled.div`
  border: 1px dashed ${colors.gray2};
  border-radius: 0.4rem;
  background: ${colors.white};
  padding: ${sizes.xLarge} ${sizes.large};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${sizes.small};
`;

export const EmptyStateTitle = styled.h3`
  margin: 0;
  font-size: 1.6rem;
  color: ${colors.charcoal};
`;

export const EmptyStateBody = styled.p`
  margin: 0;
  max-width: 52rem;
  color: ${colors.gray5};
  font-size: 1.4rem;
  line-height: 1.5;
`;

export const EmptyStateActions = styled.div`
  display: flex;
  gap: ${sizes.small};
  margin-top: ${sizes.small};
`;
